module.exports = __webpack_public_path__ + "img/勞資爭議調處 人員訓練班 (1).2601b0d8.png";